import { differenceInHours, parseISO } from 'date-fns';

export const getHoursDiff = (lastUpdateDate: string | undefined | null) => {
  if (lastUpdateDate == null || lastUpdateDate === '') return undefined;

  const lastUpdate = parseISO(lastUpdateDate);
  const now = new Date();

  return differenceInHours(now, lastUpdate);
};